module.exports = __webpack_public_path__ + "static/img/woman_glove_4.5e4cc8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/woman_glove_4.png
// module id = bW1Q
// module chunks = 0